import styles from "./CatalogDownload.module.scss";
import { useTranslation } from "next-i18next";
import cn from "classnames";
import { H2, P2 } from "@/lib/ui/components/Typography";
import { DownloadPresentation } from "@/lib/ui/components/Forms";
import { FC, useCallback, useEffect, useRef, useState } from "react";
import Image from "next/image";
import { CircleButton } from "../../../../components/Buttons";
import { NextArrowIcon } from "../../../../icons";

const tabsList: { title: string; id: string; text: string }[] = [
  {
    title: "presentation.bestInvestment",
    id: "440y1nll222d",
    text: "presentation.bestInvestmentDescription",
  },
  {
    title: "presentation.comfortableLiving",
    id: "byecerodmaap",
    text: "presentation.comfortableLivingDescription",
  },
  {
    title: "presentation.eliteVillas",
    id: "92mqieufr4r8",
    text: "presentation.eliteVillasDescription",
  },
];

const ImageCatalog = ({ language, selected }: { language: string; selected: number }) => (
  <Image
    className={styles.downloadBlock__catalogImage}
    src={`/images/catalog/catalog_${language}_${selected}.webp`}
    width={765}
    height={447}
    quality={100}
    sizes="(max-width: 1200px) 50vw, (max-width: 996px) 33vw, (max-width: 500px) 100vw"
    alt=""
  />
);

export const CatalogDownload: FC = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation("index");
  const [selected, setSelected] = useState(0);
  const tabsRef = useRef<HTMLDivElement | null>(null);

  const selectNext = useCallback(() => {
    setSelected((s) => (s + 1 > tabsList.length - 1 ? 0 : s + 1));
  }, []);
  const selectPrev = useCallback(() => {
    setSelected((s) => (s - 1 < 0 ? tabsList.length - 1 : s - 1));
  }, []);

  useEffect(() => {
    if (!tabsRef.current) return;
    let offset = 0;
    if (selected > 0) {
      const buttons = Array.from(tabsRef.current.querySelectorAll("button")).map(
        (b) => b.getBoundingClientRect().width,
      );
      offset = (() => {
        let result = 0;
        for (let i = 0; i < selected; i++) {
          result += buttons[i];
        }
        return result;
      })();
    }
    tabsRef.current.scrollLeft = offset;
  }, [selected]);

  return (
    <section className={styles.downloadBlock}>
      <div className={styles.downloadBlock__noise} />
      <Image
        alt=""
        width={1082}
        height={751}
        src={"/image.webp"}
        className={styles.downloadBlock__leaves}
      />

      <div className={cn(styles.container, styles.downloadBlock__container)}>
        <div className={styles.downloadBlock__wrapper}>
          <div className={styles.downloadBlock__left}>
            <H2>{t("form.titles.selectionFormTitle")}</H2>
            <DownloadPresentation
              className={styles.downloadBlock__form}
              // presentation={presentation}
              presentation={null}
              selectionTitle={tabsList[selected].title}
              downloadText={""}
              agreementText={"agreementSelections"}
              buttonLabel={"getTheSelection"}
              theme="white-on-blue"
              eventName={['sale', 'sale_selection']}
            />
          </div>
          <div className={styles.downloadBlock__right}>
            <ImageCatalog language={language} selected={selected + 1} />
            <div ref={tabsRef} className={styles.downloadBlock__tabs}>
              <div className={cn(styles.tab__list, styles.downloadBlock__tablist)}>
                {tabsList.map((item, i) => (
                  <button
                    className={cn(
                      styles.tab__light,
                      i === selected && "tab__light--selected",
                    )}
                    key={item.id}
                    onClick={() => setSelected(i)}
                  >
                    <P2>{t(item.title)}</P2>
                  </button>
                ))}
              </div>
            </div>
            <div className={styles.downloadBlock__buttons}>
              <CircleButton
                as={"button"}
                content={<NextArrowIcon isUpsideDown />}
                name="prev tab"
                styleType="secondary"
                onClick={selectPrev}
              />
              <CircleButton
                as={"button"}
                name="next tab"
                content={<NextArrowIcon />}
                styleType="secondary"
                onClick={selectNext}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
